import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/appData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '文章中心' },
    { to: '/about', label: '关于我们' },
  ];

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-16 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
            C
          </div>
          <span className={`font-heading font-bold text-lg ${scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'}`}>
            {siteInfo.name}
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.to
                  ? 'text-primary-500'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#download"
            className="px-5 py-2 text-sm font-semibold whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200"
          >
            立即下载
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${
            scrolled || !isHome ? 'text-foreground-700' : 'text-background-50'
          }`}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 space-y-3">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`block py-2 text-sm font-medium whitespace-nowrap ${
                location.pathname === link.to ? 'text-primary-500' : 'text-foreground-700'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="#download"
            className="block w-full text-center py-2.5 text-sm font-semibold whitespace-nowrap rounded-full bg-primary-500 text-background-50"
          >
            立即下载
          </a>
        </div>
      )}
    </nav>
  );
}